export default "__VITE_ASSET__fc19cf56__"